import axios from './axios';

// 取得所有模板
export function getAllTemplates() {
    return axios.get('/api/templates').then(res => res.data);
}

// 取得單一模板
export function getTemplateById(id) {
    return axios.get(`/api/templates/${id}`).then(res => res.data);
}

// 新增模板
export function createTemplate(template) {
    return axios.post('/api/templates', template).then(res => res.data);
}

// 更新模板
export function updateTemplate(id, template) {
    return axios.put(`/api/templates/${id}`, template).then(res => res.data);
}

// 刪除模板
export function deleteTemplate(id) {
    return axios.delete(`/api/templates/${id}`).then(res => res.status === 200 || res.status === 204);
}
